const freeLessonCards = document.querySelectorAll(".free-lesson-card");

if (freeLessonCards) {
  freeLessonCards.forEach((card) => {
    const input = card.querySelector("input");

    if (input.checked) {
      card.classList.add("checked");
    }

    card.addEventListener("click", (e) => {
      const input = e.target.closest("input");

      if (input) {
        card.classList.remove("checked");
        if (input.checked) {
          card.classList.add("checked");
        }
      }
    });
  });
}
